import { useEffect, useState } from 'react';

export const useHasFinishedCountdownToInSeconds = (seconds: number) => {
  const [hasFinished, setHasFinished] = useState(false);

  useEffect(() => {
    const countdown = setTimeout(() => {
      setHasFinished(true);
    }, seconds * 1000);

    return () => clearTimeout(countdown);
  }, []);

  return hasFinished;
};
